// import UsernameAlreadyTaken from './exceptions/UsernameAlreadyTaken'
// import EmailAlreadyTaken from './exceptions/EmailAlreadyTaken'
import {apiClient} from "@/api"; 
import { DateTime } from "luxon";

export default class RegisterForm 
{
    #email = ''
    #name = ''
    #surname = ''
    #username = ''
    #birthdate = ''
    #password = ''
    #acceptCommunications = ''
    #acceptTOS = ''

    email()
    {
        return this.#email
    }

    name()
    {
        return this.#name
    }

    surname()
    {
        return this.#surname
    }

    username()
    {
        return this.#username
    }

    birthdate()
    {
        return this.#birthdate.toFormat('MM/dd/yyyy')
    }

    password()
    {
        return this.#password
    }

    timezone()
    {
        return DateTime.local().zoneName
    }

    acceptedTOS()
    {
        return this.#acceptTOS ? 1 : 0
    }

    acceptedCommunications()
    {
        return this.#acceptCommunications ? 1 : 0
    }

    static createFromForm(email, name, surname, username, birthdate, password, acceptCommunications, acceptTOS)
    {
        let registerForm = new RegisterForm()

        registerForm.#email = email
        registerForm.#name = name
        registerForm.#surname = surname
        registerForm.#username = username
        registerForm.#birthdate = DateTime.fromSQL(birthdate)
        registerForm.#password = password
        registerForm.#acceptCommunications = acceptCommunications
        registerForm.#acceptTOS = acceptTOS

        return registerForm
    }

    async isValidForm()
    {
        return await this.isUsernameAvailable() &&
            await this.isEmailAvailable() &&
            await this.isNameValid() &&
            await this.isSurnameValid() &&
            await this.isPasswordValid() &&
            await this.areAcceptedTOSValid()
    }

    async isUsernameAvailable()
    {
        const hasUsername = await apiClient.skitudeRegisterCheckUsername(this.#username)
        return !hasUsername.data.object.exists
    }

    async isEmailAvailable()
    {
        const hasEmail = await apiClient.skitudeRegisterCheckEmail(this.#email)
        return !hasEmail.data.object.exists
    }

    isNameValid()
    {
        return this.#name != ''
    }

    isSurnameValid()
    {
        return this.#surname != ''
    }

    isPasswordValid()
    {
        return this.#password != ''
    }

    areAcceptedTOSValid()
    {
        return this.#acceptTOS;
    }
}